import { render } from "./ProfileConfig.vue?vue&type=template&id=fa307d2e&scoped=true"
import script from "./ProfileConfig.vue?vue&type=script&lang=js"
export * from "./ProfileConfig.vue?vue&type=script&lang=js"

import "./ProfileConfig.vue?vue&type=style&index=0&id=fa307d2e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa307d2e"]])

export default __exports__